import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceConfirm',
  components: {
    Loading
  },
  data () {
    return {
      processing: false
    }
  },
  computed: {
    ...mapState({
      categoryName: state => state.service.categoryName,

      // form
      userIdentity: state => state.serviceForm.targetId,
      values: state => state.serviceForm.values,

      // model
      tenantModel: state => state.serviceForm.tenantModel,
      communityModel: state => state.serviceForm.communityModel
    }),
    ...mapGetters({
      getValue: 'serviceForm/getValue'
    }),

    // result
    resultTenant () {
      try {
        return this.tenantModel.filter(item => item.tenant.tenantUuid === this.values.inpTenant)[0].tenant.name
      /* eslint-disable no-new */
      } catch (e) {
        return ''
      }
    },
    resultCommunity () {
      try {
        return this.communityModel.filter(item => item.communityUuid === this.values.inpCommunity)[0].name
      /* eslint-disable no-new */
      } catch (e) {
        return ''
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showToast: 'toast/show'
    }),
    turnBack () {
      this.$router.go(-1)
    },

    postData () {
      this.processing = true

      let parameters = {
        request: {
          serviceName: this.values.inpServiceName,
          tenantUuid: this.values.inpTenant,
          communityUuid: this.values.inpCommunity
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['service'],
        ['v1ServicePost'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '新しい' + this.categoryName + 'の登録',
              body: '「' + this.values.inpServiceName + '」を登録しました。'
            })

            this.$router.push({
              name: 'Service'
            })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    }
  }
}
